import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../icon";
export default function CheckCircle(props) {
    return (_jsxs(Icon, { ...props, children: [_jsx("path", { d: "M15.663 3.773A9 9 0 1 0 21 12v-.919a1 1 0 1 1 2 0V12A11.002 11.002 0 0 1 8.188 22.313a11 11 0 1 1 8.289-20.366 1 1 0 1 1-.814 1.826Z" }), _jsx("path", { d: "M22.707 3.293a1 1 0 0 1 0 1.414l-10 10.01a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L12 12.595l9.293-9.302a1 1 0 0 1 1.414 0Z" })] }));
}
